import React, { useMemo } from "react";
import { Card, Button, Toast } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { queryCache, useMutation } from "react-query";
import Alert from "react-s-alert";

import getEncodedImageUrl from "../../../helpers/getEncodedImageUrl";
import EmailModal from "./email-modal";
import EmailsSent from "./emails-sent";
import { ExportPresentations, ImportPresentations } from './import-export'
import { deletePresentationWithoutPpt } from "./xhr";
import confirmDeletePresentation from './delete-all-pres';

import { DownloadIcon, LinkIcon, EmailICon, SentEmailIcon, DeleteIcon } from '../../../components/svgs';


const EventCard = ({
  presentations,
  event,
  downloadAllPresentations,
  showEmailModal,
  setShowEmailModal,
  speakersProps,
  rooms,
  scheduleData,
  intl,
}) => {
  const [deletePresentationWithoutPptMutation, { isLoading }] = useMutation(deletePresentationWithoutPpt, {
    onSuccess: (insertedPresentations) => {
      queryCache.setQueryData(["event-presentations", event._id], () => insertedPresentations);
      Alert.success(intl.formatMessage({ id: "presentation.delete-success" }));
    },
    onError: (err) => {
      Alert.error(intl.formatMessage({ id: err.response.data.message }));
    },
  });

  const speakerList = useMemo(() => {
    if(!presentations) {
      return [];
    }
    let speakers = Array.from(new Set(presentations.map((p) => p.speaker_id)));
    speakers = speakers.map((sid) => {
      const speaker = speakersProps.find((s) => {
        return s._id === sid;
      });
      if(!speaker || speaker.email.indexOf('@') === -1) {
        return false;
      }
      return {
        value: sid,
        label: speaker
          ? `${speaker.title || ''} ${speaker.firstName} ${speaker.lastName}`
          : "",
      };
    });
    return speakers.filter(s => s);
  }, [presentations, speakersProps]);

  const speakersWithoutPresentations = useMemo(() => {
    if(!presentations) {
      return [];
    }
    let speakers = Array.from(new Set(presentations.filter((p) => p.ppt.length === 0).map((p) => p.speaker_id)));
    speakers = speakers.map((sid) => {
      if(!speakersProps) {
        return null;
      }
      const speaker = speakersProps.find((s) => {
        return s._id === sid;
      });
      if(!speaker || speaker.email.indexOf('@') === -1) {
        return false;
      }
      return sid;
    });
    return speakers.filter(s => s);
  }, [presentations, speakersProps]);

  const speakersWithoutVideos = useMemo(() => {
    if(!presentations) {
      return [];
    }
    let speakers = Array.from(new Set(presentations.filter((p) => p.status !== 'published').map((p) => p.speaker_id)));
    speakers = speakers.map((sid) => {
      if(!speakersProps) {
        return null;
      }
      const speaker = speakersProps.find((s) => {
        return s._id === sid;
      });
      if(!speaker || speaker.email.indexOf('@') === -1) {
        return false;
      }
      return sid;
    });
    return speakers.filter(s => s);
  }, [presentations, speakersProps]);

  function handleClose() {
    setShowEmailModal(!showEmailModal);
  }

  const [hovered, setHovered] = React.useState(false);
  const [hoveredTwo, setHoveredTwo] = React.useState(false);
  const [showEmailsSentModal, setShowEmailsSentModal] = React.useState(false);
  const [copied, setCopied] = React.useState(false);
  const [copied2, setCopied2] = React.useState(false);
  const [copied3, setCopied3] = React.useState(false);
  const [copied4, setCopied4] = React.useState(false);
console.log(event.slug,"event sluggggggg in event card");

  return (
    <Card className="presentations-card">
      <Card.Body>
        <div className="text-center custom-image-upload">
          <h3 className="m-b-20">{event.name}</h3>
          <img
            className="event-portrait rounded-circle"
            width={120}
            src={
              event.logo
                ? getEncodedImageUrl(event.logo, 120, 120)
                : "/images/default-event-ico.png"
            }
            alt=""
          />
        </div>
        <div className="d-flex site-details align-items-center">
        <span className={(hovered || hoveredTwo) ? 'hover-state' : ''}><LinkIcon /></span>
          <div className="m-l-30">
            <div>
              <span className="d-flex relative">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}
                  href={`${process.env.REACT_APP_AUDIENCE_SITE_ROOT}/${event.slug}`}
                  // pass event id 
                >
                  <span className="d-block"><FormattedMessage id="site.moderator" /></span>
                </a>
                <CopyToClipboard text={`${process.env.REACT_APP_AUDIENCE_SITE_ROOT}/${event.slug}`}
                  onCopy={() => setCopied(true)}>
                  <span className="copy-to-clip d-inline-block m-l-10"><i className="fas fa-copy"></i></span>
                </CopyToClipboard>
                <Toast className="toast-custom" onClose={() => setCopied(false)} show={copied} delay={1000} autohide>
                  <Toast.Header>
                    <small><b>{intl.formatMessage({id: 'copied.text'})}</b></small>
                  </Toast.Header>
                </Toast>
              </span>
            </div>
            <span className="d-flex m-t-10 relative">
            <a
              target="_blank"
              rel="noopener noreferrer"
              onMouseEnter={() => setHoveredTwo(true)} onMouseLeave={() => setHoveredTwo(false)}
              href={`${process.env.REACT_APP_AUDIENCE_SITE_ROOT}/${event.slug}`} //API for event site or navigation to engagement side
            >
              <span className="d-block"><FormattedMessage id="site.audience" /></span>
            </a>
            <CopyToClipboard text={`${process.env.REACT_APP_AUDIENCE_SITE_ROOT}/${event.slug}&viewmode=virtual`}
              onCopy={() => setCopied3(true)}>
              <span className="copy-to-clip d-inline-block m-l-10"><i className="fas fa-copy"></i></span>
            </CopyToClipboard>
            <Toast className="toast-custom" onClose={() => setCopied3(false)} show={copied3} delay={1000} autohide>
              <Toast.Header>
                <small><b>{intl.formatMessage({id: 'copied.text'})}</b></small>
              </Toast.Header>
            </Toast>

            </span>
            <div className="m-t-10">
              <span className="d-flex relative">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}
                  href={`${process.env.REACT_APP_AUDIENCE_SITE_ROOT}/${event.slug}&viewmode=virtual`}
                >
                  <span className="d-block">
                  {/* <FormattedMessage id="site.moderator" /> */}
                    VIRTUAL
                  </span>
                </a>
                <CopyToClipboard text={`${process.env.REACT_APP_AUDIENCE_SITE_ROOT}/${event.slug}&viewmode=virtual`}
                  onCopy={() => setCopied2(true)}>
                  <span className="copy-to-clip d-inline-block m-l-10"><i className="fas fa-copy"></i></span>
                </CopyToClipboard>
                <Toast className="toast-custom" onClose={() => setCopied2(false)} show={copied2} delay={1000} autohide>
                  <Toast.Header>
                    <small><b>{intl.formatMessage({id: 'copied.text'})}</b></small>
                  </Toast.Header>
                </Toast>
              </span>
            </div>
            <div className="m-t-10">
              <span className="d-flex relative">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}
                  href={`${process.env.REACT_APP_AUDIENCE_SITE_ROOT}/${event.slug}?iframe=true`}
                >
                  <span className="d-block">
                  {/* <FormattedMessage id="site.moderator" /> */}
                    Iframe
                  </span>
                </a>
                <CopyToClipboard text={`${process.env.REACT_APP_AUDIENCE_SITE_ROOT}/${event.slug}&iframe=true`}
                  onCopy={() => setCopied4(true)}>
                  <span className="copy-to-clip d-inline-block m-l-10"><i className="fas fa-copy"></i></span>
                </CopyToClipboard>
                <Toast className="toast-custom" onClose={() => setCopied4(false)} show={copied4} delay={1000} autohide>
                  <Toast.Header>
                    <small><b>{intl.formatMessage({id: 'copied.text'})}</b></small>
                  </Toast.Header>
                </Toast>
              </span>
            </div>
          </div>
        </div>
        {/* <div className="extend-text">
          <p>
              Vos présentations sont visibles jusqu’au{" "}
              <span>XXXX</span>
            </p>
            <a href="#">prolonger</a>
        </div> */}
        <div className="pre-vids-form">
          <ImportPresentations event={event} />
          <ExportPresentations data={presentations} event_name={event.name} foreign={{
            ...scheduleData,
            speakers: speakersProps,
            rooms,
          }} />

          <Button onClick={() => confirmDeletePresentation(intl, event._id, deletePresentationWithoutPptMutation, 'button.delete-presentations-without-ppt')} disabled={isLoading}>
            <DeleteIcon />
            <FormattedMessage id="button.delete-presentations-without-ppt" />
          </Button>

          <Button onClick={() => downloadAllPresentations()}>
            <DownloadIcon />
            {/* <img src="/images/download-presentations-ico.png" alt="delete" />{" "} */}
            <FormattedMessage id="button.presentations-all-download" />
          </Button>
          <Button
            onClick={() => setShowEmailModal(!showEmailModal)}
            className="m-t-20"
          >
            <EmailICon />
            {/* <img src="/images/contact-stakeholders-ico.png" alt="delete" /> */}
            <FormattedMessage id="button.send-email" />
          </Button>
          <Button className="m-t-20" onClick={() => setShowEmailsSentModal(true)}>
            <SentEmailIcon />
            <FormattedMessage id="show.sent.emails" />
          </Button>
          
        </div>
      </Card.Body>
      <div className="static-modal">
        <EmailModal
          event={event}
          show={showEmailModal}
          close={handleClose}
          speakers={speakerList}
          speakersWithoutPresentations={speakersWithoutPresentations}
          speakersWithoutVideos={speakersWithoutVideos}
        />
        <EmailsSent
          show={showEmailsSentModal}
          eventId={event._id}
          hide={() => setShowEmailsSentModal(false)}
        />
      </div>
    </Card>
  );
};

export default EventCard;
